<template>
  <div class="quota-bottom" v-if="bsos.length > 0">
    <div class="form-group">
      <div class="quota-fields">
        <div class="quota-field">
          <strong>{{ $t('Выданы БСО') }}</strong>
        </div>
        <div class="quota-field" v-if="issueDate">
          <span>{{ $t('Дата выдачи') }}: {{ issueDate }}</span>
        </div>
      </div>
    </div>
    <div class="table-overflow">
      <table>
        <thead>
        <tr>
          <td class="td-number">№</td>
          <td class="text-center">{{ $t('Вид животного') }}</td>
          <td class="text-center">{{ $t('Серия и № разрешения') }}</td>
          <td class="text-center">{{ $t('Серия и № отст. карты') }}</td>
          <td class="text-center">{{ $t('Серия и № троф. листа') }}</td>
          <td class="text-center" v-if="editable">{{ $t('Действия') }}</td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(bso, index) in bsos" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ bso.faunaName }}{{ bso.headCount ? '-'+bso.headCount : '' }}</td>
          <td :rowspan="bsos.length" v-if="index === 0">
            <template v-if="bso.permitFaunaLicenseApplicationBso">
              <p>
                {{ bso.permitFaunaLicenseApplicationBso.strictReportingFormTypeName }} {{ bso.permitFaunaLicenseApplicationBso.bsoNumber }} {{ bso.permitFaunaLicenseApplicationBso.validDateFrom ? $t('с') + ' ' + bso.permitFaunaLicenseApplicationBso.validDateFrom : '' }} {{ bso.permitFaunaLicenseApplicationBso.validDateTo ? $t('по') + ' ' + bso.permitFaunaLicenseApplicationBso.validDateTo : '' }}
              </p>
            </template>
          </td>
          <td>
            <template v-if="bso.strictReportingFormTypes && bso.strictReportingFormTypes.shooting_card">
              <ul>
                <li v-for="(shootingCard, i) in bso.strictReportingFormTypes.shooting_card.faunaLicenseApplicationBsos" :key="i">
                  {{ bso.strictReportingFormTypes.shooting_card.strictReportingFormTypeName }} {{ shootingCard.bsoNumber }} {{ shootingCard.validDateFrom ? $t('с') + ' ' + shootingCard.validDateFrom : '' }} {{ shootingCard.validDateTo ? $t('по') + ' ' + shootingCard.validDateTo : '' }}
                </li>
              </ul>
            </template>
          </td>
          <td>
            <template v-if="bso.strictReportingFormTypes && bso.strictReportingFormTypes.trophySheet">
              <ul>
                <li v-for="(trophySheet, i) in bso.strictReportingFormTypes.trophySheet.faunaLicenseApplicationBsos" :key="i">
                  {{ bso.strictReportingFormTypes.trophySheet.strictReportingFormTypeName }} {{ trophySheet.bsoNumber }} {{ trophySheet.validDateFrom ? $t('с') + ' ' + trophySheet.validDateFrom : '' }} {{ trophySheet.validDateTo ? $t('по') + ' ' + trophySheet.validDateTo : '' }}
                </li>
              </ul>
            </template>
          </td>
          <td :rowspan="bsos.length" v-if="editable && index === 0">
            <IssueBsoForm :licenseApplicationId="licenseApplication" :issueBsoEdit="true"/>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import IssueBsoForm from '@/components/license/IssueBsoForm'

export default {
  components: {
    IssueBsoForm
  },
  props: {
    licenseApplication: Number,
    bsos: Array,
    editable: Boolean,
    issueDate: String
  },
  data: () => ({})
}
</script>
